(function () {
  /* build: kit-reveal-fix */
  /* Mobile menu */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    function setMenu(open, restoreFocus) {
      toggle.setAttribute('aria-expanded', String(open));
      var hdr = toggle.closest('[data-header]'); if (hdr) hdr.classList.toggle('is-open', open);
      nav.hidden = !open;
      if (!open && restoreFocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setMenu(!expanded, false);
    });
    nav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setMenu(false, false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setMenu(false, true);
      }
    });
    document.addEventListener('click', function (event) {
      if (toggle.getAttribute('aria-expanded') === 'true' && !event.target.closest('[data-header]')) {
        setMenu(false, false);
      }
    });
    var desktopHeader = window.matchMedia('(min-width: 1100px)');
    var closeAtDesktop = function (event) { if (event.matches) setMenu(false, false); };
    if (desktopHeader.addEventListener) desktopHeader.addEventListener('change', closeAtDesktop);
    else desktopHeader.addListener(closeAtDesktop);
  }

  /* The approved market control couples country/currency with the supported
     report language mapped on each option. */
  var localizationSelects = document.querySelectorAll('[data-localization-select]');
  localizationSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      if (!select.form) return;
      var selected = select.selectedOptions && select.selectedOptions[0];
      var language = selected && selected.getAttribute('data-language');
      var languageInput = select.form.querySelector('input[name="language_code"]');
      if (language && languageInput) languageInput.value = language;
      select.form.requestSubmit();
    });
  });

  /* Shopify Markets can geolocate the country on a first visit without also
     selecting that market's mapped storefront language. Keep the initial
     server-selected country and the combined selector's language in sync. */
  if (localizationSelects.length) {
    var initialSelect = localizationSelects[0];
    var initialOption = initialSelect.selectedOptions && initialSelect.selectedOptions[0];
    var expectedLanguage = initialOption && initialOption.getAttribute('data-language');
    var currentLanguageInput = initialSelect.form && initialSelect.form.querySelector('input[name="language_code"]');
    var currentLanguage = currentLanguageInput && currentLanguageInput.value;
    var syncKey = 'eligens-market-language-sync';
    var syncValue = initialSelect.value + ':' + currentLanguage + '>' + expectedLanguage;

    if (expectedLanguage && currentLanguage && expectedLanguage.toLowerCase() !== currentLanguage.toLowerCase()) {
      if (sessionStorage.getItem(syncKey) !== syncValue) {
        sessionStorage.setItem(syncKey, syncValue);
        currentLanguageInput.value = expectedLanguage;
        initialSelect.form.requestSubmit();
      }
    } else {
      sessionStorage.removeItem(syncKey);
    }
  }

  /* Content tabs */
  document.querySelectorAll('[data-tabs]').forEach(function (root) {
    var buttons = root.querySelectorAll('[data-tab-btn]');
    var panels = root.querySelectorAll('[data-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tab-btn');
        buttons.forEach(function (b) { b.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        btn.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('[data-tab-panel="' + id + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* ---------- Scroll-reveal micro-animations ---------- */
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupReveal() {
    var selectors = [
      '.section-header', '.product-card', '.feature-split__content', '.feature-split__media',
      '.stat', '.step-card', '.testimonial', '.feature-pill', '.data-trust__card',
      '.order-box', '.kit-item', '.finder__card', '.finder__q', '.app-promo__content',
      '.app-promo__visual', '.hero-home__content', '.hero-home__visual', '.landing-hero__content',
      '.landing-hero__media', '.category-tile', '.upsell-banner__inner', '.compare-section .section-header',
      '.page-hero__title', '.page-hero__lead', '.instruction-step', '.video-hero__inner',
      '.kit-contents__visual', '.kit-list__item', '.sciproof__head', '.sciproof-card',
      '.about-hero__copy', '.about-hero__visual', '.about-mission__head', '.about-mission__card',
      '.about-global__head', '.about-global__coverage', '.about-global__map', '.about-global__service', '.about-office',
      '.rd .hero-copy', '.rd .hero-visual', '.rd .section-head', '.rd .pcard', '.rd .book',
      '.rd .kitprocess__visual', '.rd .kitprocess__body', '.rd .card', '.rd .chapters .split',
      '.rd .techcol', '.rd .depth', '.rd .pub', '.rd .labvideo', '.rd .faq details',
      '.rd .pstrip .inner', '.rd .final .wrap'
    ];
    var nodes = [];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute('data-reveal')) { el.setAttribute('data-reveal', ''); nodes.push(el); }
      });
    });

    if (prefersReduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }

    /* stagger siblings within the same grid/row */
    nodes.forEach(function (el) {
      var parent = el.parentElement;
      if (!parent) return;
      var sibs = Array.prototype.filter.call(parent.children, function (c) { return c.hasAttribute('data-reveal'); });
      var idx = sibs.indexOf(el);
      if (idx > 0) el.style.setProperty('--reveal-delay', Math.min(idx, 6) * 70 + 'ms');
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (el) { io.observe(el); });
  }
  setupReveal();

  /* ---------- About-page metric count-up ---------- */
  function setupAboutCountUp() {
    var nodes = document.querySelectorAll('[data-count-up]');
    if (!nodes.length || prefersReduced || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var node = entry.target;
        var original = node.textContent.trim();
        var target = parseInt(node.getAttribute('data-count-target') || original.replace(/\D/g, ''), 10);
        if (!Number.isFinite(target) || node.dataset.counted === 'true') {
          observer.unobserve(node);
          return;
        }
        var suffix = original.includes('+') ? '+' : '';
        var startedAt = performance.now();
        node.dataset.counted = 'true';
        node.setAttribute('aria-label', original);
        function tick(now) {
          var progress = Math.min((now - startedAt) / 900, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          node.textContent = Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(tick);
          else node.textContent = original;
        }
        node.textContent = '0' + suffix;
        requestAnimationFrame(tick);
        observer.unobserve(node);
      });
    }, { threshold: 0.6 });

    nodes.forEach(function (node) { observer.observe(node); });
  }
  setupAboutCountUp();

  /* ---------- Background video: lazy play / pause offscreen ---------- */
  document.querySelectorAll('[data-bg-video], .video-hero__media video').forEach(function (video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    if (prefersReduced) { video.removeAttribute('autoplay'); video.pause(); return; }
    if ('IntersectionObserver' in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
          else { video.pause(); }
        });
      }, { threshold: 0.15 });
      vio.observe(video);
    }
  });

  /* ---------- Video modal (play button) ---------- */
  document.querySelectorAll('[data-video-modal-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modal = document.querySelector('[data-video-modal="' + btn.getAttribute('data-video-modal-open') + '"]');
      if (!modal) return;
      var frame = modal.querySelector('iframe, video');
      var src = frame && frame.getAttribute('data-src');
      if (frame && src && !frame.getAttribute('src')) frame.setAttribute('src', src);
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-video-modal]').forEach(function (modal) {
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      var f = modal.querySelector('iframe');
      if (f) { var s = f.getAttribute('src'); f.setAttribute('src', ''); if (s) f.setAttribute('data-src', s); }
      var v = modal.querySelector('video'); if (v) v.pause();
    }
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.hasAttribute('data-video-close')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* Glass header: one material for everyone. The appearance (light / dark) switches
     whole, by the share of dark content under the bar, with hysteresis (>=60% dark,
     <=40% light). The premium template is always dark. Edge refraction (tier 3) is
     Chromium-only and gated here, because @supports passes url() filters that Firefox
     and Safari then do not render. */
  var glassHeader = document.querySelector('[data-header]');
  if (glassHeader) {
    var forceDark = /template-product-(whole-genome|genome)(\s|$)/.test(document.body.className);
    var darkEls = [];
    var headerDark = forceDark;
    function collectDark() { darkEls = Array.prototype.slice.call(document.querySelectorAll('.hero,.reviews,.emotional,.final,.lab,.site-footer,.pstrip .inner,.premium')); }
    function runGlass() {
      if (forceDark) { glassHeader.classList.add('is-dark'); return; }
      var b = glassHeader.getBoundingClientRect(); if (b.height <= 0) return;
      var px = 0;
      for (var i = 0; i < darkEls.length; i++) { var r = darkEls[i].getBoundingClientRect(); var t = Math.max(r.top, b.top), bo = Math.min(r.bottom, b.bottom); if (bo > t) px += bo - t; }
      var share = px / b.height; if (share >= .6) headerDark = true; else if (share <= .4) headerDark = false;
      glassHeader.classList.toggle('is-dark', headerDark);
    }
    collectDark(); runGlass();
    window.addEventListener('scroll', runGlass, { passive: true });
    window.addEventListener('resize', function () { collectDark(); runGlass(); });
    var chromiumUA = /Chrome\/\d+/.test(navigator.userAgent);
    var canBackdrop = window.CSS && (CSS.supports('backdrop-filter', 'blur(1px)') || CSS.supports('-webkit-backdrop-filter', 'blur(1px)'));
    var reducedTransparency = window.matchMedia && window.matchMedia('(prefers-reduced-transparency: reduce)').matches;
    if (chromiumUA && canBackdrop && !reducedTransparency && !prefersReduced) {
      var buildMap = function (w, h, bezel) {
        var cv = document.createElement('canvas'); cv.width = w; cv.height = h; var g = cv.getContext('2d'); var img = g.createImageData(w, h); var d = img.data;
        for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
          var dx = Math.min(x, w - 1 - x), dy = Math.min(y, h - 1 - y); var e = Math.min(dx, dy); var t = Math.min(1, e / bezel);
          var slope = t < 1 ? Math.pow(1 - t, 3) / Math.max(.02, Math.pow(1 - Math.pow(1 - t, 4), .75)) : 0;
          var ang = Math.atan(slope); var refr = Math.asin(Math.sin(ang) / 1.5); var mag = Math.min(1, Math.tan(ang - refr));
          var nx = 0, ny = 0; if (dx < dy) nx = x < w / 2 ? 1 : -1; else if (dy < dx) ny = y < h / 2 ? 1 : -1; else { nx = x < w / 2 ? .7 : -.7; ny = y < h / 2 ? .7 : -.7; }
          var i = (y * w + x) * 4; d[i] = 128 + Math.round(nx * mag * 127); d[i + 1] = 128 + Math.round(ny * mag * 127); d[i + 2] = 128; d[i + 3] = 255;
        }
        g.putImageData(img, 0, 0); return cv.toDataURL();
      };
      var svgNS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(svgNS, 'svg'); svg.setAttribute('width', '0'); svg.setAttribute('height', '0'); svg.setAttribute('aria-hidden', 'true'); svg.style.position = 'absolute';
      svg.innerHTML = '<filter id="eg-refract" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB"><feImage id="eg-map" result="map" preserveAspectRatio="none"/><feDisplacementMap in="SourceGraphic" in2="map" scale="22" xChannelSelector="R" yChannelSelector="G"/></filter>';
      document.body.appendChild(svg);
      var mapEl = svg.querySelector('#eg-map');
      var sizeMap = function () { var b = glassHeader.getBoundingClientRect(); var w = Math.max(64, Math.min(1024, Math.round(b.width))), h = Math.max(16, Math.round(b.height)); var url = buildMap(w, h, 18); mapEl.setAttribute('href', url); mapEl.setAttributeNS('http://www.w3.org/1999/xlink', 'href', url); };
      sizeMap(); document.body.classList.add('has-refract');
      var mapTimer; window.addEventListener('resize', function () { clearTimeout(mapTimer); mapTimer = setTimeout(sizeMap, 200); });
    }
  }

  /* Sticky buy bar */
  var stickyBar = document.querySelector('[data-sticky-buy]');
  var buyAnchor = document.querySelector('[data-buy-anchor]');
  if (stickyBar && buyAnchor) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var visible = !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', visible);
        document.body.classList.toggle('sticky-buy-visible', visible);
      });
    }, { threshold: 0 });
    observer.observe(buyAnchor);
    stickyBar.querySelector('[data-sticky-buy-btn]')?.addEventListener('click', function (event) {
      event.preventDefault();
      buyAnchor.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });
    });
  }

  /* Shopify Customer Privacy currently injects English for Latvian. Keep the
     native consent behavior, but replace its customer-visible copy with the
     locale strings rendered by Liquid. */
  var privacyTranslations = null;
  var privacyTranslationsElement = document.getElementById('EligensPrivacyTranslations');
  if (privacyTranslationsElement) {
    try {
      privacyTranslations = JSON.parse(privacyTranslationsElement.textContent);
    } catch (error) {
      privacyTranslations = null;
    }
  }

  function setPrivacyText(selector, value) {
    var element = document.querySelector(selector);
    if (element && value) element.textContent = value;
  }

  function setPrivacyLabelText(selector, value) {
    var label = document.querySelector(selector);
    if (!label || !value) return;
    var textNode = Array.prototype.find.call(label.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE;
    });
    if (textNode) textNode.nodeValue = value;
    else label.insertBefore(document.createTextNode(value), label.firstChild);
  }

  function localizePrivacyUi() {
    if (!privacyTranslations) return;

    var banner = document.getElementById('shopify-pc__banner');
    if (banner && !banner.dataset.eligensLocalized) {
      banner.dataset.eligensLocalized = 'true';
      setPrivacyText('#shopify-pc__banner__body-title', privacyTranslations.title);
      setPrivacyText('#shopify-pc__banner__btn-manage-prefs', privacyTranslations.manage);
      setPrivacyText('#shopify-pc__banner__btn-accept', privacyTranslations.accept);
      setPrivacyText('#shopify-pc__banner__btn-decline', privacyTranslations.decline);

      var policyParagraph = banner.querySelector('.shopify-pc__banner__body p');
      var policyLink = document.getElementById('shopify-pc__banner__body-policy-link');
      if (policyParagraph && policyLink) {
        policyLink.textContent = privacyTranslations.policyLink;
        policyParagraph.textContent = privacyTranslations.description + ' ';
        policyParagraph.appendChild(policyLink);
        policyParagraph.appendChild(document.createTextNode('.'));
      }
    }

    var preferences = document.getElementById('shopify-pc__prefs');
    if (preferences && !preferences.dataset.eligensLocalized) {
      preferences.dataset.eligensLocalized = 'true';
      setPrivacyText('#shopify-pc__prefs__header-title', privacyTranslations.preferencesTitle);
      setPrivacyText('#shopify-pc__prefs__header-accept', privacyTranslations.acceptAll);
      setPrivacyText('#shopify-pc__prefs__header-decline', privacyTranslations.declineAll);
      setPrivacyText('#shopify-pc__prefs__header-save', privacyTranslations.save);
      var closeButton = document.getElementById('shopify-pc__prefs__header-close');
      if (closeButton) closeButton.setAttribute('aria-label', privacyTranslations.close);
      setPrivacyText('.shopify-pc__prefs__intro-main h3', privacyTranslations.controlTitle);
      setPrivacyText('.shopify-pc__prefs__intro-main p', privacyTranslations.controlText);
      setPrivacyLabelText('#shopify-pc__prefs__essential label', privacyTranslations.required);
      setPrivacyText('#shopify-pc__prefs__essential > p', privacyTranslations.requiredText);
      setPrivacyLabelText('#shopify-pc__prefs__preferences label', privacyTranslations.personalization);
      setPrivacyText('#shopify-pc__prefs__preferences > p', privacyTranslations.personalizationText);
      setPrivacyLabelText('#shopify-pc__prefs__marketing label', privacyTranslations.marketing);
      setPrivacyText('#shopify-pc__prefs__marketing > p', privacyTranslations.marketingText);
      setPrivacyLabelText('#shopify-pc__prefs__analytics label', privacyTranslations.analytics);
      setPrivacyText('#shopify-pc__prefs__analytics > p', privacyTranslations.analyticsText);
    }
  }

  function syncPrivacyBanner() {
    localizePrivacyUi();
    var banner = document.getElementById('shopify-pc__banner');
    var visible = false;
    if (banner) {
      var style = window.getComputedStyle(banner);
      var rect = banner.getBoundingClientRect();
      visible = style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      banner.querySelectorAll('button').forEach(function (button) {
        if (button.dataset.rdPrivacyBound) return;
        button.dataset.rdPrivacyBound = 'true';
        button.addEventListener('click', function () {
          window.requestAnimationFrame(syncPrivacyBanner);
        });
      });
    }
    document.body.classList.toggle('privacy-banner-visible', visible);
  }
  syncPrivacyBanner();
  if (document.body && 'MutationObserver' in window) {
    var privacyObserver = new MutationObserver(function () {
      syncPrivacyBanner();
    });
    privacyObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
  }

  var policyConsentSwitch = document.getElementById('cookiePanelPolicySwitch');
  if (policyConsentSwitch) {
    policyConsentSwitch.setAttribute('role', 'button');
    policyConsentSwitch.setAttribute('tabindex', '0');
    function showPrivacyPreferences() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    }
    policyConsentSwitch.addEventListener('click', showPrivacyPreferences);
    policyConsentSwitch.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        showPrivacyPreferences();
      }
    });
  }

  /* Smart app download: send iOS/Android visitors to the matching store when URLs exist. */
  var appDownload = document.querySelector('[data-app-download]');
  if (appDownload) {
    var iosUrl = appDownload.getAttribute('data-app-store-url') || '';
    var androidUrl = appDownload.getAttribute('data-play-store-url') || '';
    var ua = navigator.userAgent || '';
    var isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var isAndroid = /Android/i.test(ua);
    var statusEl = appDownload.querySelector('[data-app-download-status]');
    var target = '';
    if (isIOS && iosUrl) target = iosUrl;
    else if (isAndroid && androidUrl) target = androidUrl;
    if (target) {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = isIOS
          ? (statusEl.getAttribute('data-status-ios') || 'Opening the App Store…')
          : (statusEl.getAttribute('data-status-android') || 'Opening Google Play…');
      }
      window.setTimeout(function () {
        window.location.replace(target);
      }, 350);
    }
  }
  /* Hide Shop Pay wallet buttons; leave Apple Pay / Google Pay. */
  function isShopPayLabel(text) {
    var t = String(text || '').toLowerCase();
    if (!t) return false;
    if (t.indexOf('apple') !== -1 || t.indexOf('google') !== -1) return false;
    return t.indexOf('shop pay') !== -1 || t.indexOf('buy with shop') !== -1 || t.indexOf('shop-pay') !== -1;
  }

  function hideShopPayNode(node) {
    if (!node || node.nodeType !== 1) return;
    var tag = (node.tagName || '').toLowerCase();
    if (tag === 'shop-pay-wallet-button' || tag === 'shop-pay-button' || tag === 'shopify-pay-button') {
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('hidden', '');
      return;
    }
    var label = [
      node.getAttribute('aria-label'),
      node.getAttribute('data-wallet-id'),
      node.getAttribute('data-testid'),
      node.getAttribute('title'),
      node.id,
      node.className
    ].join(' ');
    if (isShopPayLabel(label)) {
      node.style.setProperty('display', 'none', 'important');
      node.setAttribute('hidden', '');
      return;
    }
    if (node.shadowRoot) {
      Array.prototype.forEach.call(node.shadowRoot.children || [], hideShopPayNode);
      Array.prototype.forEach.call(node.shadowRoot.querySelectorAll('*'), hideShopPayNode);
    }
    Array.prototype.forEach.call(node.children || [], hideShopPayNode);
  }

  function hideShopPayButtons() {
    Array.prototype.forEach.call(
      document.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, shop-pay-wallet-button, shop-pay-button'),
      hideShopPayNode
    );
  }

  hideShopPayButtons();
  var shopPayTries = 0;
  var shopPayTimer = window.setInterval(function () {
    hideShopPayButtons();
    shopPayTries += 1;
    if (shopPayTries > 24) window.clearInterval(shopPayTimer);
  }, 250);
  if (document.body) {
    new MutationObserver(hideShopPayButtons).observe(document.body, { childList: true, subtree: true });
  }
})();
